import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDNBlevAVHpAfSlhuXOnGqOoOpZUrpbi7Q",
    authDomain: "ictaznipa.firebaseapp.com",
    projectId: "ictaznipa",
    storageBucket: "ictaznipa.firebasestorage.app",
    messagingSenderId: "641992499402",
    appId: "1:641992499402:web:c26ea4577db270cef69433"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();

export { firestore };
